import { useContext } from "react";
import { useSelector } from "react-redux";
import { Preferences } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editPreferences(preferences: Preferences): void;
}

function useEditPreferences(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isEditPreferencesRequestPending),
    isRequestSuccess: useSelector(selector.isEditPreferencesRequestSuccess),
    isRequestFailure: useSelector(selector.isEditPreferencesRequestFailure),
    editPreferences: core.editPreferences,
  };
}

export { useEditPreferences };
